module.exports = __webpack_public_path__ + "img/KSC03395.80bd2e1f.jpg";